import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const CustomDropdown = ({ data, selectedEventId, handleSelectChangeTheme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("Select Event");

  const handleSelect = (item) => {
    setSelectedValue(`${item.event_name} - ${item.theme_name}`);
    handleSelectChangeTheme(item);
    setIsOpen(false);
  };

  return (
    <div className="dropdown" style={{ position: 'relative', }}>
      <div
        className="dropdown__selected"
        style={{
          padding: '10px',
          cursor: 'pointer',
          whiteSpace: "nowrap",
          width: "90%",
          display:"block",
          textOverflow: "ellipsis",
          overflow: "hidden",
        }}
        onClick={() => setIsOpen(!isOpen)}

      >
        {selectedValue} <span style={{position:"absolute", right:10, top:10}}>{isOpen ? <FiChevronUp /> : <FiChevronDown />}</span>
      </div>

      {isOpen && (
        <ul
          className="dropdown__list"
          style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            right: '0',
            maxHeight: '150px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            listStyle: 'none',
            padding: '0',
            margin: '0',
            zIndex: '1000',
          }}
        >
          {data.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item)}
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                wordWrap: "break-word"
              }}
            >
              {item.event_name} - {item.theme_name}
              {item.number_events > 1 && item.event_index && (
                <span style={{ fontSize: '0.85em', color: '#666', marginLeft: '5px' }}>
                  (#{item.event_index})
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
